export default __webpack_public_path__ + "static/media/Dr-anand-josh-profile.ed574552.jpg";